import { ReadWellLogo } from "../assets/images";
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const AppLogo = (props) => {
    const { containerStyle, textStyle} = props;
    return (
        <div className={containerStyle}>
            <ReadWellLogo/>
            <Typography className={textStyle}>ReadRivals</Typography>
        </div>
    )
};
AppLogo.prototype = {
    containerStyle:PropTypes.string.isRequired,
    textStyle:PropTypes.string.isRequired
}
export default AppLogo;